export default __webpack_public_path__ + "fa4e7c44dc7c64ffa86c6fa1de97c0ae.webp";